import React from "react";

import Container from "@mui/material/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import { Navigate, Route, Routes } from "react-router-dom";
import RequireRoles from "../auth/RequireRoles";
import ProjectView from "./ProjectView";
import ProgramBrowseView from "./ProgramBrowseView";
import ProgramView from "./ProgramView";
import { usePrograms } from "./cspServices";

const ADMIN = ["ROLE_ADMIN"];

const ManageCSPsView = () => {
  const programsResponse = usePrograms();

  return (
    <Container id="manage-subscriptions" disableGutters>
      <ApplicationHeader />

      <Routes>
        <Route
          path="programs"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-programs">
                <ProgramBrowseView programsResponse={programsResponse} />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route
          path="programs/:programId/projects/:projectId"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-project">
                <ProjectView />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route
          path="programs/:programId"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-program">
                <ProgramView />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route index element={<Navigate to="programs" replace />} />
      </Routes>
    </Container>
  );
};

export default ManageCSPsView;
